<template>
    <section class="page-content">
        <!-- <TopBackgroundComponent/> -->
        <CareerDetailComponent/>
    </section>
</template>

<script setup>
    // import TopBackgroundComponent from '../components/TopBackgroundComponent.vue';
    import CareerDetailComponent from '@/components/career/CareerDetailComponent.vue';
    window.scrollTo(0, 0);
</script>

<style scoped>
    /*  */
</style>